import { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Table } from 'reactstrap';

const CategoryPoints = ({ data }) => {
  const [bookingCategories, setBookingCategories] = useState([]);

  useEffect(() => {
    setBookingCategories(
      data?.bookingReport?.bookingAcrossCategory?.map(d => ({
        name: d?.entity?.name,
        count: d?.count ?? 0,
      })) || [],
    );
  }, [data?.bookingReport?.bookingAcrossCategory]);

  const grandTotal = bookingCategories?.reduce((total, category) => total + category.count, 0);

  return (
    <Col xl={6} md={6} className="mb-4">
      <Card>
        <CardHeader>
          <h4 className="mb-0">Category Points Redemption</h4>
        </CardHeader>
        <CardBody style={{ maxHeight: '300px', overflowY: 'scroll', position: 'relative', paddingBottom: '60px' }}>
          <Table striped bordered hover responsive style={{ marginBottom: '0' }}>
            <thead className="table-light">
              <tr>
                <th className="text-start">Particulars</th>
                <th className="text-start">Counts</th>
              </tr>
            </thead>
            <tbody>
              {bookingCategories.length > 0 ? (
                bookingCategories.map((category, index) => (
                  <tr key={index}>
                    <td>{category.name}</td>
                    <th scope="row">{category.count}</th>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2" className="text-center">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
        {bookingCategories?.length > 0 && (
          <div style={{ position: 'absolute', bottom: '0', width: '100%', background: 'white' }}>
            <Table striped bordered hover responsive style={{ marginBottom: '0' }}>
              <tfoot className="table-light">
                <tr>
                  <th>Grand Total</th>
                  <th>{grandTotal}</th>
                </tr>
              </tfoot>
            </Table>
          </div>
        )}
      </Card>
    </Col>
  );
};

export default CategoryPoints;
